import PortfolioCoinTransactionController from "./portfolio_coin_transactions_controller";
import { EventPriceChanged } from "../events";
import { getActiveCurrency } from "../util/currency";

export default class extends PortfolioCoinTransactionController {
  updateCoinIdValue() {
    this.coinIdTarget.value = event.currentTarget.dataset.coinId;
  }

  onPostSuccess(e) {
    let [data, status, xhr] = e.detail;
    const successResponse = JSON.parse(xhr.response);


    this._clearFormErrors();
    this.postMessageTarget.classList.add("text-primary");
    this.postMessageTarget.innerHTML = successResponse.message;
    this._updateBalanceBtc(successResponse.balance_btc);
  }


  _updateBalanceBtc(balance_btc) {
    this.balanceTarget.dataset.priceBtc = balance_btc;

    this.element.dispatchEvent(
      new CustomEvent(EventPriceChanged, {
        bubbles: true,
        detail: {
          currencyCode: getActiveCurrency()
        }
      })
    );
  }
}
